module.exports = __webpack_public_path__ + "static/media/NI.85c41223.png";